import React from 'react';
import AgentTipBubbleView from './View';
import { useAgentTipBubbleLogic } from './hooks/useAgentTipBubbleLogic';
import type { IAgentTipBubbleProps } from './types';

/**
 * AgentTipBubble 容器组件（Layer 1→2→3 组装层）
 * 职责：
 * 1. 调用 Layer 2 业务逻辑 Hook
 * 2. 将数据和回调传递给 Layer 1 纯展示组件
 */
const AgentTipBubble: React.FC<IAgentTipBubbleProps> = (props) => {
  const { children } = props;

  const {
    feedbackVisible,
    handleNavigateToAgent,
    handleCopilotMode,
    handleGoToGPT,
    handleOpenFeedback,
    handleCloseFeedback,
  } = useAgentTipBubbleLogic();

  const trigger = React.cloneElement(children, {
    onClick: (event: React.MouseEvent) => {
      children.props.onClick?.(event);
      handleNavigateToAgent();
    },
  });

  return (
    <AgentTipBubbleView
      // eslint-disable-next-line react/no-children-prop
      children={trigger}
      feedbackVisible={feedbackVisible}
      onFullscreenMode={handleNavigateToAgent}
      onCopilotMode={handleCopilotMode}
      onGoToGPT={handleGoToGPT}
      onOpenFeedback={handleOpenFeedback}
      onCloseFeedback={handleCloseFeedback}
    />
  );
};

export default AgentTipBubble;
